import React from "react";
import { Grid, Box, Modal, Typography } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import styles from "./RepresentativePopup.module.css";
import { FiCheck } from "react-icons/fi";

const OptionPopup = ({ open, close, optionData }) => {
  return (
    <div>
      <Modal
        open={open}
        onClose={close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.description_container}>
          <Box display={"flex"} justifyContent={"space-between"}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              ADDED OPTION
            </Typography>
            <Box fontSize={"24px"} sx={{ cursor: "pointer" }} onClick={close}>
              <RxCross2 />
            </Box>
          </Box>
          <hr />
          <Grid
            item
            xs={12}
            sx={{ mt: 4 }}
            display={"flex"}
            width={"100%"}
            gap={"15%"}
          >
            <Grid
              item
              xs={12}
              width={"100%"}
              className={styles.feature_content}
            >
              <Typography sx={{ mt: 2 }} fontSize={"12px"}>
                {optionData?.length > 0 &&
                  optionData.map((value, index) => {
                    return (
                      value !== "" && (
                        <ul key={value.id}>
                          <span className={styles.vehicle_list_data}>
                            <FiCheck className={styles.check_button} />
                            <span className={styles.list_data}>
                              {value.name}
                            </span>
                            <span className={styles.list_data}>
                              - {value.price}
                            </span>
                          </span>
                        </ul>
                      )
                    );
                  })}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default OptionPopup;
